import { Grid } from "@material-ui/core";
import React from "react";
import { SectionProps } from "../SectionProps";
import { QuestionOneSection } from "./QuestionOneSection";
import { QuestionTwoSection } from "./QuestionTwoSection";
import { SocItemDetailsAo } from "../../../domain/SocItemDetailsAo";
import { QuestionThreeSection } from "./QuestionThreeSection";

export const OrganisationalStability: React.FC<SectionProps<SocItemDetailsAo>> = (
  sectionProps
) => {


  return (
    <Grid container spacing={3}>
      <QuestionOneSection {...sectionProps} />
      <QuestionTwoSection {...sectionProps} />
      <QuestionThreeSection sectionProps={sectionProps} />
    </Grid>
  );
};
